import axios from "axios";
import { BASE_URL, TIMEOUT } from "./config";
import { handleNetworkError } from "./error-status";

class Request {
	constructor(baseURL, timeout) {
		this.instance = axios.create({
			baseURL,
			timeout,
		});

		this.instance.interceptors.request.use(
			(req) => {
				// token inject
				return req;
			},
			(err) => {
				return Promise.reject(err);
			}
		);

		this.instance.interceptors.response.use(
			(res) => {
				// 请求成功判断
				if (res.status === 200) {
					return res.data.resData;
				} else {
					// response error todo
					throw new Error(res.data.errMsg);
				}
			},
			(err) => {
				// request failed todo
				if (err && err.response) handleNetworkError(err.response?.status);
			}
		);
	}

	request(config) {
		return this.instance.request(config);
	}

	get(config) {
		return this.request({
			...config,
			method: "get",
		});
	}

	post(config) {
		return this.request({
			...config,
			method: "post",
		});
	}

	delete(config) {
		return this.request({
			...config,
			method: "delete",
		});
	}
}

const request = new Request(BASE_URL, TIMEOUT);

export default request;
